<div [style]="{ margin: '1em' }" *ngIf="entity">
  <div class="p-grid nested-grid p-mt-3">
    <div class="p-col-12 p-lg-12">
      <p-card>
        <div [ngSwitch]="this.entity.type">
          <!-- Login Rewards Day 1-7 Type-->
          <div class="p-grid" *ngSwitchCase="1">
            <div class="grid-container">
              <div *ngFor="let dayReward of dailyRewards; let i = index">
                <div *ngIf="dayReward.day !== 7" class="grid-item">
                  <div class="reward-card p-shadow-4">
                    <h4 class="day-title">Day {{ dayReward.day }}</h4>
                    <div *ngFor="let reward of dayReward.rewards; let j = index" class="internal-card">
                      <div class="reward-layout">
                        <img *ngIf="getRewardImage(reward)"
                            [src]="getRewardImage(reward)"
                            alt="Reward Thumbnail"
                            class="item-thumbnail"
                            [style]="{ width: '80px', height: '80px' }">
                        <div class="reward-info">
                          <p class="reward-detail">
                            <span class="p-text-bold">{{ reward.lineItemType }}:</span> {{ reward.id?.name }}
                          </p>
                          <a [href]="getLink(reward)" target="_blank" class="item-id"
                            [ngStyle]="{ color: 'var(--primary-color)' }">
                            {{ reward.id?.id }}
                          </a>
                          <div class="item-quantity pill">
                            <span class="p-text-bold">Quantity:</span> {{ reward.c }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!--Day 7 -->
              <div class="grid-item-large">
                <div class="reward-card p-shadow-4">
                  <h4 class="day-title">Day 7</h4>
                  <div *ngFor="let reward of day7Rewards; let k = index" class="internal-card">
                    <div class="reward-layout">
                      <img *ngIf="getRewardImage(reward) !== 'default_image_path_here'"
                           [src]="getRewardImage(reward)"
                           alt="Reward Thumbnail"
                           class="item-thumbnail"
                          [style]="{ width: '80px', height: '80px' }">
                      <div class="reward-info">
                        <p class="reward-detail">
                          <span class="p-text-bold">{{ reward.lineItemType }}:</span> {{ reward.id?.name }}
                        </p>
                        <a [href]="getLink(reward)" target="_blank" class="item-id"
                          [ngStyle]="{ color: 'var(--primary-color)' }">
                          {{ reward.id?.id }}
                        </a>
                        <div class="item-quantity pill">
                          <span class="p-text-bold">Quantity:</span> {{ reward.c }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Login Rewards Day 30 -->
          <div *ngSwitchCase="2" style="display:flex; justify-content:center;">
          <div class="grid-item-large">
            <div class="reward-card p-shadow-4">
              <h4 class="day-title">Day 30</h4>
              <div *ngFor="let reward of entity.dailyRewardDay30; let k = index" class="internal-card">
                <div class="reward-layout">
                  <img *ngIf="reward.id?.thumbnail_ref?.thumbnails?.length > 4"
                       [src]="reward.id.thumbnail_ref.thumbnails[4].path"
                       alt="Item Thumbnail"
                       class="item-thumbnail"
                       [style]="{ width: '80px', height: '80px' }">
                  <div class="reward-info">
                    <p class="reward-detail">
                      <span class="p-text-bold">{{ reward.lineItemType }}:</span> {{ reward.id?.name }}
                    </p>
                    <a [href]="getLink(reward)" target="_blank" class="item-id"
                       [ngStyle]="{ color: 'var(--primary-color)' }">
                      {{ reward.id?.id }}
                    </a>
                    <div class="item-quantity pill">
                      <span class="p-text-bold">Quantity:</span> {{ reward.c }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          </div>
          <!-- Free Garden Pass -->
          <div *ngSwitchCase="3">
            <p-timeline class="p-mt-2" [value]="parsedSeasonPass" align="alternate">
              <ng-template pTemplate="marker" let-event>
                <span class="custom-marker shadow-3">
                  <p-badge [value]="event[0]"></p-badge>
                </span>
              </ng-template>
              <ng-template pTemplate="content" let-event>
                <div class="reward-card-compact p-shadow-4">
                  <h4 class="day-title-compact">Event {{ event[0] }}</h4>
                  <div class="rewards-container">
                    <div *ngFor="let reward of event[1]; let i = index" class="internal-card-compact">
                      <div class="reward-layout-compact">
                        <img *ngIf="getRewardImage(reward)"
                            [src]="getRewardImage(reward)"
                            alt="Reward Thumbnail"
                            class="item-thumbnail-compact">
                        <div class="reward-info-compact">
                          <p class="reward-detail-compact">
                            <span class="p-text-bold">{{ reward.lineItemType }}:</span> {{ reward.id?.name }}
                          </p>
                          <a [href]="getLink(reward)" target="_blank" class="item-id-compact"
                            [ngStyle]="{ color: 'var(--primary-color)' }">
                            {{ reward.id?.id }}
                          </a>
                          <div class="item-quantity pill">
                            <span class="p-text-bold">Quantity:</span> {{ reward.c }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
            </p-timeline>
          </div>
          <!-- Paid Garden Pass -->
          <div *ngSwitchCase="4">
            <p-timeline class="p-mt-2" [value]="parsedSeasonPass" align="alternate">
              <ng-template pTemplate="marker" let-event>
                <span class="custom-marker shadow-3">
                  <p-badge [value]="event[0]"></p-badge>
                </span>
              </ng-template>
              <ng-template pTemplate="content" let-event>
                <div class="reward-card-compact p-shadow-4">
                  <h4 class="day-title-compact">Event {{ event[0] }}</h4>
                  <div class="rewards-container">
                    <div *ngFor="let reward of event[1]; let i = index" class="internal-card-compact">
                      <div class="reward-layout-compact">
                        <img *ngIf="getRewardImage(reward)"
                            [src]="getRewardImage(reward)"
                            alt="Reward Thumbnail"
                            class="item-thumbnail-compact">
                        <div class="reward-info-compact">
                          <p class="reward-detail-compact">
                            <span class="p-text-bold">{{ reward.lineItemType }}:</span> {{ reward.id?.name }}
                          </p>
                          <a [href]="getLink(reward)" target="_blank" class="item-id-compact"
                            [ngStyle]="{ color: 'var(--primary-color)' }">
                            {{ reward.id?.id }}
                          </a>
                          <div class="item-quantity pill">
                            <span class="p-text-bold">Quantity:</span> {{ reward.c }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
            </p-timeline>
          </div>
          <!-- Friends Invited Track -->
          <div *ngSwitchCase="5">
            <p-timeline class="p-mt-2" [value]="parsedSeasonPass" align="alternate">
              <ng-template pTemplate="marker" let-event>
                <span class="custom-marker shadow-3">
                  <p-badge [value]="event[0]"></p-badge>
                </span>
              </ng-template>
              <ng-template pTemplate="content" let-event>
                <p-card styleClass="p-my-1 p-shadow-7">
                  <div *ngFor="let reward of event[1]; let i = index">
                    <p-divider *ngIf="i > 0"></p-divider>
                    <div *ngIf="reward.lineItemType === 'Item'">
                      <span class="p-text-bold">Reward Type: </span><span>{{reward.lineItemType}}</span>
                      <div class="reward-layout">
                        <img *ngIf="reward.id?.thumbnail_ref?.thumbnails?.length > 4"
                          [src]="reward.id.thumbnail_ref.thumbnails[4].path" alt="Item Thumbnail"
                          class="item-thumbnail">
                        <span class="item-quantity pill">{{reward.c}}</span>
                        <span class="item-name">{{ reward.id?.name }}</span>
                        <a [href]="getLink(reward)" target="_blank" class="item-id"
                          [ngStyle]="{ color: 'var(--primary-color)' }">
                          {{ reward.id?.id }}
                        </a>
                      </div>
                    </div>
                    <div *ngIf="reward.lineItemType !== 'Item'">
                      <span class="p-text-bold">Reward Type: </span><span>{{reward.lineItemType}}</span>
                      <div class="p-text-bold">Quantity: </div><span>{{reward.c}}</span>
                      <div class="p-text-bold">Reward: </div>
                      <span>{{ reward.id?.name }}</span>
                      <a [href]="getLink(reward)" target="_blank" class="p-text-normal"
                        [ngStyle]="{ color: 'var(--primary-color)' }">
                        {{ reward.id?.id }}
                      </a>
                    </div>
                  </div>
                </p-card>
              </ng-template>
            </p-timeline>
          </div>
          <!-- Endless Offer -->
          <div *ngSwitchCase="6">
            <app-endless-offer-track-v2 [eoTrack]="entity" [parentEntity]="''"></app-endless-offer-track-v2>
          </div>
          <!-- Co-Op Rewards Track -->
          <div *ngSwitchCase="7">
            <p-timeline class="p-mt-2" [value]="parsedSeasonPass" align="alternate">
              <ng-template pTemplate="marker" let-event>
                <span class="custom-marker shadow-3">
                  <p-badge [value]="event[0]"></p-badge>
                </span>
              </ng-template>
              <ng-template pTemplate="content" let-event>
                <div class="reward-card-compact p-shadow-4">
                  <h4 class="day-title-compact">Event {{ event[0] }}</h4>
                  <div class="rewards-container">
                    <div *ngFor="let reward of event[1]; let i = index" class="internal-card-compact">
                      <div class="reward-layout-compact">
                        <img *ngIf="getRewardImage(reward)"
                            [src]="getRewardImage(reward)"
                            alt="Reward Thumbnail"
                            class="item-thumbnail-compact">
                        <div class="reward-info-compact">
                          <p class="reward-detail-compact">
                            <span class="p-text-bold">{{ reward.lineItemType }}:</span> {{ reward.id?.name }}
                          </p>
                          <a [href]="getLink(reward)" target="_blank" class="item-id-compact"
                            [ngStyle]="{ color: 'var(--primary-color)' }">
                            {{ reward.id?.id }}
                          </a>
                          <div class="item-quantity pill">
                            <span class="p-text-bold">Quantity:</span> {{ reward.c }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
            </p-timeline>
          </div>
          <!-- Mini Games -->
          <div *ngSwitchCase="8">
            <p-timeline class="p-mt-2" [value]="parsedSeasonPass" align="alternate">
              <ng-template pTemplate="marker" let-event>
                <span class="custom-marker shadow-3">
                  <p-badge [value]="event[0]"></p-badge>
                </span>
              </ng-template>
              <ng-template pTemplate="content" let-event>
                <div class="reward-card-compact p-shadow-4">
                  <h4 class="day-title-compact">Rewards</h4>
                  <div class="rewards-container">
                    <div *ngFor="let reward of event[1]; let i = index" class="internal-card-compact">
                      <div class="reward-layout-compact">
                        <img *ngIf="getRewardImage(reward)"
                            [src]="getRewardImage(reward)"
                            alt="Reward Thumbnail"
                            class="item-thumbnail-compact">
                        <div class="reward-info-compact">
                          <p class="reward-detail-compact">
                            <span class="p-text-bold">{{ reward.lineItemType }}:</span> {{ reward.id?.name }}
                          </p>
                          <a [href]="getLink(reward)" target="_blank" class="item-id-compact"
                            [ngStyle]="{ color: 'var(--primary-color)' }">
                            {{ reward.id?.id }}
                          </a>
                          <div class="item-quantity pill">
                            <span class="p-text-bold">Quantity:</span> {{ reward.c }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
            </p-timeline>
          </div>
          <!-- Seasonal Prizes -->
          <div *ngSwitchCase="9">
            <p-timeline class="p-mt-2" [value]="parsedSeasonPass" align="alternate">
              <ng-template pTemplate="marker" let-event>
                <span class="custom-marker shadow-3">
                  <p-badge [value]="event[0]"></p-badge>
                </span>
              </ng-template>
              <ng-template pTemplate="content" let-event>
                <div class="reward-card-compact p-shadow-4">
                  <h4 class="day-title-compact">Rewards</h4>
                  <div class="rewards-container">
                    <div *ngFor="let reward of event[1]; let i = index" class="internal-card-compact">
                      <div class="reward-layout-compact">
                        <img *ngIf="getRewardImage(reward)"
                            [src]="getRewardImage(reward)"
                            alt="Reward Thumbnail"
                            class="item-thumbnail-compact">
                        <div class="reward-info-compact">
                          <p class="reward-detail-compact">
                            <span class="p-text-bold">{{ reward.lineItemType }}:</span> {{ reward.id?.name }}
                          </p>
                          <a [href]="getLink(reward)" target="_blank" class="item-id-compact"
                            [ngStyle]="{ color: 'var(--primary-color)' }">
                            {{ reward.id?.id }}
                          </a>
                          <div class="item-quantity pill">
                            <span class="p-text-bold">Quantity:</span> {{ reward.c }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
            </p-timeline>
          </div>
          <!-- Daily Goals/Activities -->
          <div *ngSwitchCase="10">
            <p-timeline class="p-mt-2" [value]="parsedSeasonPass" align="alternate">
              <ng-template pTemplate="marker" let-event>
                <span class="custom-marker shadow-3">
                  <p-badge [value]="event[0]"></p-badge>
                </span>
              </ng-template>
              <ng-template pTemplate="content" let-event>
                <div class="reward-card-compact p-shadow-4">
                  <h4 class="day-title-compact">Rewards</h4>
                  <div class="rewards-container">
                    <div *ngFor="let reward of event[1]; let i = index" class="internal-card-compact">
                      <div class="reward-layout-compact">
                        <img *ngIf="getRewardImage(reward)"
                            [src]="getRewardImage(reward)"
                            alt="Reward Thumbnail"
                            class="item-thumbnail-compact">
                        <div class="reward-info-compact">
                          <p class="reward-detail-compact">
                            <span class="p-text-bold">{{ reward.lineItemType }}:</span> {{ reward.id?.name }}
                          </p>
                          <a [href]="getLink(reward)" target="_blank" class="item-id-compact"
                            [ngStyle]="{ color: 'var(--primary-color)' }">
                            {{ reward.id?.id }}
                          </a>
                          <div class="item-quantity pill">
                            <span class="p-text-bold">Quantity:</span> {{ reward.c }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
            </p-timeline>
          </div>
          <!-- Gifting Tree V2 -->
          <div class="p-grid" *ngSwitchCase="12">
            <div class="grid-container">
              <div *ngFor="let event of parsedSeasonPass" class="grid-item">
                <div class="reward-card p-shadow-4">
                  <h4 class="day-title">Stage {{ event[0] }}</h4>
                  <div *ngFor="let reward of event[1]" class="internal-card">
                    <div class="reward-layout">
                      <img *ngIf="getRewardImage(reward)"
                          [src]="getRewardImage(reward)"
                          alt="Reward Thumbnail"
                          class="item-thumbnail"
                          [style]="{ width: '80px', height: '80px' }">
                      <div class="reward-info">
                        <p class="reward-detail">
                          <span class="p-text-bold">{{ reward.lineItemType }}:</span> {{ reward.id?.name }}
                        </p>
                        <a [href]="getLink(reward)" target="_blank" class="item-id"
                          [ngStyle]="{ color: 'var(--primary-color)' }">
                          {{ reward.id?.id }}
                        </a>
                        <div class="item-quantity pill">
                          <span class="p-text-bold">Quantity:</span> {{ reward.c }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Perk Daily Rewards -->
          <div class="p-grid" *ngSwitchCase="11">
            <div class="grid-container">
              <div *ngFor="let dayReward of dailyRewards" class="grid-item">
                <div class="reward-card p-shadow-4">
                  <h4 class="day-title">Day {{ dayReward.day }}</h4>
                  <div *ngFor="let reward of dayReward.rewards" class="internal-card">
                    <div class="reward-layout">
                      <img *ngIf="getRewardImage(reward)"
                          [src]="getRewardImage(reward)"
                          alt="Reward Thumbnail"
                          class="item-thumbnail"
                          [style]="{ width: '80px', height: '80px' }">
                      <div class="reward-info">
                        <p class="reward-detail">
                          <span class="p-text-bold">{{ reward.lineItemType }}:</span> {{ reward.id?.name }}
                        </p>
                        <a [href]="getLink(reward)" target="_blank" class="item-id"
                          [ngStyle]="{ color: 'var(--primary-color)' }">
                          {{ reward.id?.id }}
                        </a>
                        <div class="item-quantity pill">
                          <span class="p-text-bold">Quantity:</span> {{ reward.c }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </p-card>
    </div>
  </div>
</div>
